// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container[data-v-23676035] {\n    position: relative;\n    min-height: 340px;\n}\n.placement[data-v-23676035] {\n    position: absolute;\n    right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
